import { cn } from "@/lib/utils";
import { SERIES_BG, SERIES_FILL_SOFT, SERIES_STROKE } from "./opsColors";

/** 12-week trend for a KPI tile. Scales to its box; the stroke stays 1.5px. */
export function Sparkline({ values, label, className }: { values: number[]; label: string; className?: string }) {
  const n = values.length;
  const max = Math.max(1, ...values);
  const y = (v: number) => 22 - (v / max) * 20;
  const pts = values.map((v, i) => `${n > 1 ? (i / (n - 1)) * 100 : 50},${y(v)}`).join(" ");
  const lastY = y(values[n - 1] ?? 0);
  return (
    <div className={cn("relative h-6 min-w-0 flex-1", className)} title={`${label}: ${values.join(", ")}`}>
      <svg viewBox="0 0 100 24" preserveAspectRatio="none" className="absolute inset-0 w-full h-full overflow-visible" aria-hidden>
        {n > 0 && <polygon points={`0,24 ${pts} 100,24`} className={SERIES_FILL_SOFT} />}
        {n > 1 && <polyline points={pts} fill="none" strokeWidth={1.5} vectorEffect="non-scaling-stroke" strokeLinejoin="round" className={SERIES_STROKE} />}
      </svg>
      {n > 0 && (
        <span className={cn("absolute right-0 w-1.5 h-1.5 -mr-[3px] -mt-[3px] rounded-full ring-1 ring-card", SERIES_BG)} style={{ top: `${(lastY / 24) * 100}%` }} />
      )}
    </div>
  );
}
